<template>
  <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Fokontany : {{ fokontany.ll_fokontany }}
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="_.sortBy(Groupes, ['nom_groupe'])" :search="search">
        <template v-slot:item.projets="{ item }">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            color="red"
            v-if="item.projets.length === 0"
          >
            <v-icon>
              mdi-alert-circle-outline
            </v-icon>
          </v-btn>

          <ul v-else :class="redPink(item.projets)">
            <li
              v-for="(projets, indexprojets) in item.projets"
              :key="indexprojets"
            >
              {{ projets.ll_programme }}
            </li>
          </ul>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="row">
            <div class="col">
              <v-btn
                outlined
                x-small
                fab
                dark
                class="success mr-2"
                @click="detailsGroupe(item)"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div>
           <!--  <div class="col">
              <DialogAssignGroupToUser
                :groupe="item"
                @reloadAfficher="GetGroupesDeRegions()"
              />
            </div>
            <div class="col">
              <DialogLinkGroupAndProjets
                :groupe="item"
                @reloadAfficher="GetGroupesDeRegions()"
              />
            </div> -->
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    DialogLinkGroupAndProjets: require("@/components/DialogLinkGroupAndProjets.vue")
      .default,
    DialogAssignGroupToUser: require("@/components/superviseur/DialogAssignGroupToUser.vue")
      .default,
  },
  data() {
    return {
      fokontany: {},
      Groupes: [],
      search: "",
      headers: [
        { text: "Groupe", value: "nom_groupe" },
        { text: "Projets", value: "projets" },
        { text: "Animateurs", value: "nom_responsable" },
        { text: "Fokontany", value: "ll_fokontany" },
        { text: "Commune", value: "ll_commune" },
        { text: "District", value: "ll_district" },
        { text: "Région", value: "ll_region" },
        { text: "Province", value: "ll_province" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  mounted() {
    this.GetInfos();
  },
  methods: {
    redPink(projets) {
      if (projets.length === 0) {
        return "redPink";
      }
    },
    editItem(item) {
      console.log(item);
    },

    deleteItem(item) {
      this.$confirm("Voulez vous vraiment supprimer ce fokontany?").then((res) => {
        if (res) {
          console.log(item);
        }
      });
    },
    detailsGroupe(item) {
      let projet = item.projets[0].ll_programme;
      this.$router.push({
        path: `/detailsGroupe/${item.id}`,
        query: { projet: projet },
      });
    },

    GetInfos() {
      let self = this;
      var docRef = this.$firebase
        .firestore()
        .collection("fokontanys")
        .doc(this.$route.params.id);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());

            self.fokontany = doc.data();

            //self.Groupes = [];
            self.$firebase
              .firestore()
              .collection("groupes")
              .where("code_fokontany", "in", [self.$route.params.id.toString(),self.$route.params.id])
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  self.Groupes.push({
                    ...doc.data(),
                    id: doc.id,
                  });
                });
              })
              .catch((error) => {
                console.log("Error getting documents: ", error);
              });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.redPink {
  background-color: darksalmon;
}
</style>
